import { LoanCrud } from "./loanCrud";

export default function PayoutLoan(){
    return <LoanCrud name="批复客户" type="payout" router="passedLoans" />
}